import { DateManager, MathManager } from "@payments-checkout/shared/helpers/index";
import { isLanguagePortuguese } from "@payments-checkout/shared/helpers/translations/internacional-address.helpers";
import { Recurrences } from "../../types/paymentLink.types";

const recurrenceDetailItemsBuilder = ({pureItems, locale}:{pureItems?: Recurrences, locale: string}) => {
  if (!pureItems) return [];
  const localeParam = isLanguagePortuguese(locale) ? 'pt-BR' : 'en-US';

  return pureItems.map((item) => {
    return {
      plan: {
        name: item.plan.name,
        description: item.plan.description,
        startAt: item?.start_at && DateManager.showOnlyDate(item.start_at, localeParam),
        totalCost: MathManager.formatCurrency({
          value: item.plan.total_cost / 100,
        }),
        interval: item.plan.interval,
        intervalCount: item.plan.interval_count.toString(),
        cycles: item.plan?.items ? item.plan?.items[0].cycles : 0,
        membershipTax: item.setup?.amount
          ? MathManager.formatCurrency({ value: (item.setup?.amount ?? 0) / 100 })
          : undefined,
      },
    };
  });
};

export { recurrenceDetailItemsBuilder };

